import { isMobile, isLite, isEmbedVideo, isLivestreaming, isDirectVideo } from 'shared/vidio_helpers';
import { HERMES_HOST } from 'shared/env';
import GoogleTagAdapter from 'components/shared/GoogleTagAdapter/GoogleTagAdapter';
import GooglePublisherTag from 'components/shared/GooglePublisherTag/GooglePublisherTag';
import DesktopBannerAd from '../../desktop/BannerAd/BannerAd';
import MobileBannerAd from '../../mobile/BannerAd/BannerAd';
import { localStorageAdapter } from '../../../commons/BrowserStorage/LocalStorageAdapter';
import UrlUtils from '../../../../../deprecated/assets/javascripts/shared/url_utils';
import Topic from '../../../../../deprecated/assets/javascripts/shared/topic.js'
import { HermesClient } from '../HermesClient/hermesClient';

const Cookies = require('js-cookie');
const localStoreAdapter = localStorageAdapter("vidio_ads");

export const PAGE_TYPE_WATCHPAGE = 1;
export const PAGE_TYPE_SEARCH = 2;

export default class BannerAd {
  static setup() {
    if(!BannerAd.shouldSetupBannerAd()) {
      return;
    }

    if(BannerAd.isWatchPage()){
      return BannerAd.getHermesEndpoint()
        .then(endpoint => HermesClient.hitHermesEndpoint(endpoint))
        .then(response => BannerAd.useHermesResponse(response))
        .catch(err => console.error(err))
    }
  }

  static shouldSetupBannerAd() {
    if(window.kmklabs === undefined || window.kmklabs.gpt === undefined) {
      return false;
    }

    if(window.__adsConfig && window.__adsConfig.enable_premier_user_banner_ads == "true") {
      return true;
    }

    var premiumCookie = Cookies.get("_vidio");
    if(!this.isWatchPage() && window.isUserSignedIn && premiumCookie === "true") {
      return false;
    }

    return true;
  }

  static isWatchPage(){
    return isDirectVideo() || isLivestreaming() || isEmbedVideo();
  }

  static setBannerAd(container_id, ad_slot_name, ad_unit, ad_size, displayBannerFunction, refreshFunction) {
    var bannerContainer = document.getElementById(container_id);
    if(bannerContainer) {
      var bannerDiv = document.createElement("div");
      bannerDiv.id = ad_slot_name;
      bannerDiv.className = 'ad-slot';
      bannerContainer.appendChild(bannerDiv);

      displayBannerFunction(ad_unit, ad_size);

      if(refreshFunction){
        GoogleTagAdapter.push(refreshFunction);
      }
    }
  }

  static setBannerSectionAd(sourceId, adUnit, adSize, displayBannerFunction) {
    var containerId = 'banner-gam-container-' + sourceId;
    var bannerContainer = document.getElementById(containerId);

    if(bannerContainer) {
      var bannerDiv = document.createElement("div");
      bannerDiv.id = 'banner-gam';
      bannerContainer.appendChild(bannerDiv);

      displayBannerFunction(sourceId, adUnit, adSize, 'banner-gam');
    }
  }

  static isMobileAds() {
    return isMobile() || isLite();
  }

  static setupDisplayAds() {
    if(this.isMobileAds()) {
      MobileBannerAd.setup();
    } else {
      DesktopBannerAd.setup();
    }
  }

  static getHermesEndpoint() {
    return new Promise(resolve => {
      Topic.subscribeOnce('player/player/loaded', () => {
        const endpoint = BannerAd.hermesEndpoint();
        resolve(endpoint)
      });

      Topic.subscribeOnce('player/ready', () => {
        const endpoint = BannerAd.hermesEndpoint();
        resolve(endpoint)
      });
  
      const endpoint = BannerAd.hermesEndpoint();
      if(endpoint != null){
        resolve(endpoint)
      }
    })
  }

  static useHermesResponse(response) {
    BannerAd.setHermesAdUnitSize(response);
    BannerAd.setDisplayTargeting(response);
    BannerAd.setupDisplayAds();
  }

  static hermesEndpoint() {
    var url = HERMES_HOST + "/api/tags";
    return BannerAd.appendHermesQueryParams(url, PAGE_TYPE_WATCHPAGE);
  }

  static appendHermesQueryParams(endpoint, page_type = null) {
    try {
      if(page_type === PAGE_TYPE_WATCHPAGE) {
        return window.player?.adsParams().addHermesQueryParams(endpoint);
      }
      
      const device = this.isMobileAds() ? "mobile" : "desktop";
      let queryParams = {
        d: device,
        vvid: window.kmklabs?.gtm?.visitor_id || "",
      }
      const watcherId = localStoreAdapter.getItem("vidio_user_id");
      if (watcherId) {
        queryParams["wid"] = watcherId;
      }
      if(page_type === PAGE_TYPE_SEARCH) {
        queryParams["ct"] = "Search";
      }

      return UrlUtils.addQueryParams(endpoint, queryParams);
    } catch (e) {
      throw new Error(e)
    }
  }


  static setHermesAdUnitSize({ display: displayAd }) {
    if(!displayAd) return

    if(displayAd.leaderboard && displayAd.leaderboard.ad_unit && displayAd.leaderboard.size?.length > 0) {
      var lb_ad_slot = displayAd.leaderboard.ad_unit;
      var lb_ad_size = BannerAd.getSizes(displayAd.leaderboard.size);
      window.kmklabs.gpt.leaderboard_ad_unit = lb_ad_slot;
      window.kmklabs.gpt.leaderboard_ad_size = lb_ad_size;
    }

    if(displayAd.top_banner && displayAd.top_banner.ad_unit && displayAd.top_banner.size?.length > 0) {
      var tb_ad_slot = displayAd.top_banner.ad_unit;
      var tb_ad_size = BannerAd.getSizes(displayAd.top_banner.size);
      window.kmklabs.gpt.top_banner_ad_unit = tb_ad_slot;
      window.kmklabs.gpt.top_banner_ad_size = tb_ad_size;
    }

    if(displayAd.middle_banner && displayAd.middle_banner.ad_unit && displayAd.middle_banner.size?.length > 0) {
      var mb_ad_slot = displayAd.middle_banner.ad_unit;
      var mb_ad_size = BannerAd.getSizes(displayAd.middle_banner.size);
      window.kmklabs.gpt.middle_banner_ad_unit = mb_ad_slot;
      window.kmklabs.gpt.middle_banner_ad_size = mb_ad_size;
    }

    if(displayAd.pause_ad && displayAd.pause_ad.ad_unit && displayAd.pause_ad.size?.length > 0) {
      var pause_ad_slot = displayAd.pause_ad.ad_unit;
      var pause_ad_size = BannerAd.getSizes(displayAd.pause_ad.size);
      window.kmklabs.gpt.pause_ad_unit = pause_ad_slot;
      window.kmklabs.gpt.pause_ad_size = pause_ad_size;
    }

    if(displayAd.overlay && displayAd.overlay.ad_unit && displayAd.overlay.size?.length > 0) {
      var overlay_ad_slot = displayAd.overlay.ad_unit;
      var overlay_ad_size = BannerAd.getSizes(displayAd.overlay.size);
      window.kmklabs.gpt.overlay_ad_unit = overlay_ad_slot;
      window.kmklabs.gpt.overlay_ad_size = overlay_ad_size;
    }
  }
  
  static setDisplayTargeting({ display_targeting: displayTargeting }) {
    if (!displayTargeting) return;
 
    let targeting = displayTargeting.reduce((previous, current) => {
      const { key: k, value: v } = current;
      return { ...previous, ...{[k]: v} }
    }, {})

    GooglePublisherTag.setTargeting(targeting);
  }

  static getSizes(sizes) {
    return `[${sizes.reduce((prev, curr, i) => {
      if(i === sizes.length - 1) return prev += `[${curr.width},${curr.height}]`
      return prev += `[${curr.width},${curr.height}],` 
    }, "")}]`
  }
}